<!--
Author: TangChen
Date: 2018-09-10
Desc: 校验密码手机号或银行卡页面鉴权组件
 -->
<template>
    <div>
        <div class="comp-reset-num comp">
            <div v-if="!checkBank && !isTradeReset && pwdPattern" class="bizcomp-reset-lpwd-title">
                找回登录密码
                <span class="lpwd-title-tip">登录密码可用于快速登录网站/网上交易/APP/微信</span>
            </div>
            <div class="reset-num-box">
                <step :navs="navs" />
                <div
                    v-if="!phoneChecked && !navs[1].active && !checkBank && !isTradeReset"
                    class="send-mobile-text"
                >
                    验证手机号码
                </div>
                <div class="check-acct">
                    <div v-if="phoneChecked" class="info-box">
                        <img
                            :src="require('../../assets/img/warn-blue.svg')"
                            alt=""
                            class="warn-blue"
                        />
                        <span>您的手机号码已绑定交易账户，请您进行身份验证</span>
                    </div>
                    <el-form
                        v-if="phoneChecked"
                        ref="pwdForm"
                        :model="pwdForm"
                        :rules="rules"
                        label-width="446px"
                        inline-message
                        class="user-info-checked"
                        v-on:submit.native.prevent
                    >
                        <el-form-item label="姓名:" prop="userName">
                            <el-input
                                v-model.trim="pwdForm.userName"
                                placeholder="请输入真实姓名"
                                :maxlength="20"
                            />
                        </el-form-item>
                        <el-form-item label="证件类型:" prop="certType">
                            <el-select
                                v-model="pwdForm.certType"
                                placeholder="请选择证件类型"
                                v-on:change="changeCertType"
                            >
                                <el-option
                                    v-for="item in certTypes"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="证件号码:" prop="certNo">
                            <el-input
                                v-model.trim="pwdForm.certNo"
                                placeholder="请输入证件号码"
                                :maxlength="20"
                            />
                        </el-form-item>
                        <div class="btn-contain">
                            <button class="cancel-btn" v-on:click="returnCheck">返回</button>
                            <button class="next-btn" v-on:click="submitInfo('pwdForm')">
                                下一步
                            </button>
                        </div>
                        <!--<el-form-item v-if="phoneChecked" label="" class="form-text">
                        <div class="step-info">
                            以上身份信息与本人不符，放弃该交易账户，
                            <span class="info-btn" v-on:click.prevent="showPwd(true)">进入下一步</span>
                        </div>
                    </el-form-item>-->
                    </el-form>
                    <el-form
                        v-if="!checked"
                        ref="pwdForm"
                        :model="pwdForm"
                        :rules="rules"
                        label-width="446px"
                        inline-message
                        v-on:submit.native.prevent
                    >
                        <el-form-item
                            v-if="checkBank || isTradeSmsReset"
                            label="证件类型:"
                            prop="certType"
                        >
                            <el-select
                                v-model="pwdForm.certType"
                                placeholder="请选择证件类型"
                                :disabled="tradeIdentityReadonly"
                                v-on:change="checkCertNoAgain"
                            >
                                <el-option
                                    v-for="item in certTypes"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if="checkBank || isTradeSmsReset"
                            label="证件号码:"
                            prop="certNo"
                        >
                            <span v-if="tradeIdentityReadonly">{{ pwdForm.certNo }}</span>
                            <el-input
                                v-else
                                v-model.trim="pwdForm.certNo"
                                placeholder="请输入证件号码"
                                :maxlength="20"
                                v-on:input="resetTradeSmsVerifyState"
                            />
                        </el-form-item>
                        <el-form-item
                            v-if="checkBank || isTradeSmsReset"
                            label="真实姓名:"
                            prop="userName"
                        >
                            <span v-if="tradeIdentityReadonly">{{ pwdForm.userName }}</span>
                            <el-input
                                v-else
                                v-model.trim="pwdForm.userName"
                                placeholder="请输入真实姓名"
                                :maxlength="20"
                                :disabled="tradeIdentityReadonly"
                                v-on:input="resetTradeSmsVerifyState"
                            />
                        </el-form-item>
                        <el-form-item
                            v-if="checkBank"
                            label="选择银行卡:"
                            prop="bankType"
                            class="bank"
                        >
                            <div
                                class="bank-msg"
                                :style="{ opacity: bankInfo.channelid ? 1 : 0 }"
                                v-on:click.prevent="showBank"
                            >
                                <div
                                    v-if="bankInfo.channelid"
                                    class="bank-img-sel clear"
                                    :class="{ 'bg-w': bankInfo.channelid }"
                                >
                                    <img :src="$util.getImg(bankInfo.bankcode)" alt="" />
                                    <span class="k-text-flow" :title="bankInfo.bankname">
                                        {{ bankInfo.bankname.toString().substr(0, 6) }}
                                    </span>
                                    <i
                                        aria-hidden="true"
                                        class="paycenter"
                                        :title="bankInfo.paycentername"
                                    >
                                        {{ bankInfo.paycentername.toString().substr(0, 4) }}
                                    </i>
                                </div>
                            </div>
                            <el-input
                                v-model.trim="pwdForm.bankType"
                                placeholder="请选择银行卡"
                                :maxlength="20"
                                suffix-icon="fa fa-money-check"
                                :disabled="chooseBankDisable"
                            />
                        </el-form-item>
                        <el-form-item v-if="checkBank" label="银行卡号码:" prop="bankNo">
                            <div
                                class="bank-code el-message--warning"
                                :class="{
                                    show: showBankCard && pwdForm.bankNo !== ''
                                }"
                            >
                                {{ $util.getNewCard(pwdForm.bankNo) }}
                            </div>
                            <el-input
                                v-model.trim="pwdForm.bankNo"
                                placeholder="请输入完整银行卡号码"
                                :maxlength="20"
                                v-on:focus="showBankCard = true"
                                v-on:blur="showBankCard = false"
                            />
                        </el-form-item>

                        <el-form-item
                            v-if="!phoneChecked"
                            :label="checkBank ? '预留手机号' : '手机号码'"
                            prop="mobileno"
                        >
                            <el-input
                                v-model.trim="pwdForm.mobileno"
                                :placeholder="plaC"
                                :maxlength="11"
                                :disabled="isTradeSmsReset"
                                v-on:input="resetTradeSmsVerifyState"
                            />
                        </el-form-item>

                        <el-form-item
                            v-if="
                                (!phoneChecked && !checkBank) ||
                                (!phoneChecked &&
                                    checkBank &&
                                    (bankInfo.bankauthtype == '1' ||
                                        (bankInfo.bankauthtype == '0' &&
                                            bankInfo.identifytype == '1')))
                            "
                            label="短信验证码:"
                            prop="verifyCode"
                        >
                            <el-input
                                v-model.trim="pwdForm.verifyCode"
                                placeholder="请输入验证码"
                                :maxlength="6"
                            >
                                <span
                                    slot="suffix"
                                    :disabled="time > 0"
                                    :class="time > 0 ? 'get-verify-disabled' : 'get-verify'"
                                    v-on:click="mobileCode"
                                >
                                    {{ btnMsg }}
                                </span>
                            </el-input>
                        </el-form-item>
                        <!--<el-form-item v-if="(!phoneChecked && !checkBank) || (bankInfo && bankInfo.bankauthtype=='1')" label="手机验证码:" prop="verifyCode">
                        <el-input
                            v-model.trim="pwdForm.verifyCode"
                            placeholder="请输入手机验证码"
                            :maxlength="6"
                        >
                            <el-button
                                slot="append"
                                class="get-verify"
                                :disabled="time>0"
                                v-on:click="mobileCheck"
                            >
                                {{ btnMsg }}
                            </el-button>
                        </el-input>
                    </el-form-item>-->
                        <div class="btn-contain">
                            <button class="cancel-btn" v-on:click="returnBack">取消</button>
                            <button class="next-btn" v-on:click="handleResetNext">下一步</button>
                        </div>
                    </el-form>
                </div>
                <bank-lists
                    v-if="checkBank"
                    ref="bankList"
                    :bank-visible="bankVisible"
                    :bank-auth="true"
                    :required-bank-card-list="requiredBankCardList"
                    v-on:bank-hide="getBankMsg"
                />
                <set-pwd
                    v-if="pwdShow"
                    :pwd-con="pwdSet"
                    :proto="true"
                    :isReset="true"
                    class="set-pwd-comp"
                    v-on:pwd-get="pwdOk"
                />
                <img-code
                    :dialog-visible="dialogVisible"
                    :biztype="biztype"
                    v-on:verify-in="getVerifyCode"
                />
                <result
                    v-if="pwdResult"
                    :result="result"
                    v-on:login-now="findPwd"
                    v-on:return-login="backLogin"
                    v-on:return-back="returnBack"
                    v-on:return-home="backHome"
                />
            </div>
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            class="footer-questions"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import bankLists from "@/components/form/bankListsDc.vue";
import step from "@/components/layout/step.vue";
import setPwd from "@/components/layout/setPwdDc.vue";
import imgCode from "@/components/layout/imgCode.vue";
import result from "@/components/layout/resultDc.vue";
import userApi from "@/api/user";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";

export default {
    name: "ResetNum",
    components: {
        bankLists,
        setPwd,
        imgCode,
        result,
        step,
        footerQuestions
    },
    props: {
        way: {
            type: String,
            default: ""
        },
        pwdPattern: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            time: 0, // 验证码再次发送间隔
            mobileno: "",
            pwdForm: {
                // 表单参数配置
                userName: "",
                certType: "00",
                certNo: "",
                bankType: "",
                bankNo: "",
                mobileno: "",
                verifyCode: "",
                en_certificateno: "",
                en_custname: ""
            },
            acctInfo: {
                // 用户信息表单参数配置
                name: "",
                certNo: ""
            },
            showBankCard: false,
            // 密码参数设置
            pwdSet: {
                text: "登录"
            },
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您好，登录密码已重置成功！",
                btnMsg: "该密码用于登录系统",
                btnL: {
                    // ctd: "秒后自动跳转登录",
                    // time: 10,
                    // event: "return-login",
                },
                btnR: {
                    text: "确定",
                    event: "return-login"
                }
            },
            randomToken: "", // 页面鉴权的随机生成数
            phoneChecked: false, // 是否手机校验通过
            tradeIdentityChecked: false,
            infoChecked: "0", // 是否校验用户身份信息
            pwdShow: false, // 是否显示密码重置页面
            pwdResult: false, // 是否显示密码修改结果页
            bankVisible: false, // 是否弹出银行卡列表
            dialogVisible: false, // 是否显示图片验证码弹框
            mobileVisible: false, // 是否显示手机验证码弹框
            checked: false, // 手机或银行卡校验是否通过
            chooseBankDisable: false, // 是否禁用选择银行卡
            navs: [
                { val: "验证身份信息", active: true },
                { val: "设置新密码" },
                { val: "完成修改" }
            ], // 导航栏配置 // 导航栏配置
            certTypes: [], // 证件类型
            btnMsg: "获取验证码",
            plaC: "请输入手机号码",
            checkBank: false, // 是否是银行卡校验
            locked: false, // 是否已发送短信验证码
            bankInfo: {},
            biztype: "",
            rules: {
                // 校验规则
                userName: [
                    {
                        required: true,
                        message: "请输入真实姓名",
                        trigger: "change"
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (this.tradeIdentityReadonly) {
                                callback();
                                return;
                            }
                            this.$util.validateName(rule, value, callback, this.pwdForm.certType);
                        },
                        trigger: "blur"
                    }
                ],
                certType: [
                    {
                        required: true,
                        message: "请选择证件类型",
                        trigger: "change"
                    }
                ],
                certNo: [
                    {
                        required: true,
                        message: "请输入证件号码",
                        trigger: "change"
                    },
                    { validator: this.checkCertNo, trigger: "blur" }
                ],
                bankType: [
                    {
                        required: true,
                        message: "请选择所属银行",
                        trigger: "blur"
                    }
                ],
                bankNo: [
                    {
                        required: true,
                        message: "请输入银行卡号码",
                        trigger: "change"
                    },
                    { validator: this.$util.validateBankNum, trigger: "blur" }
                ],
                mobileno: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "change"
                    },
                    { validator: this.validateLoginMobileno, trigger: "blur" }
                ],
                verifyCode: [
                    {
                        required: true,
                        message: "请输入短信验证码",
                        trigger: "change"
                    },
                    {
                        validator: this.$util.validateVerifyCode,
                        trigger: "blur"
                    }
                ]
            },
            warningHtml: "",
            commonQuestion: [],
            requiredBankCardList: []
        };
    },
    computed: {
        // 非空；0-单密码 1-多密码
        passwordType() {
            return this.$cache.getCompanyInfoParam("10109008");
        },
        // 10102053=1 时，登录后重置交易密码改走三要素+短信校验；0/空保持银行卡鉴权。
        resetTradePwdAuthMode() {
            const value = this.$cache.getCompanyInfoParam("10102053");
            return value === undefined || value === null || value === "" ? "0" : String(value);
        },
        isTradeReset() {
            return this.way === "trade";
        },
        isTradeSmsReset() {
            return this.isTradeReset && this.resetTradePwdAuthMode === "1";
        },
        useTradeBankAuth() {
            return this.isTradeReset && !this.isTradeSmsReset;
        },
        tradeIdentityReadonly() {
            return this.useTradeBankAuth;
        }
    },
    created() {
        this.warningHtml = warningHtml.warningHtml1;
        this.commonQuestion = this.$const.commonQuestion.commonQuestion1;
        this.checkBank = this.useTradeBankAuth;
        // 银行卡鉴权模式沿用登录态身份信息；短信模式需要用户重新输入三要素。
        if (this.useTradeBankAuth) {
            let info = this.$cache.getUser();
            this.pwdForm.certType = info.certificatetype;
            this.pwdForm.certNo = info.certificateno;
            this.pwdForm.userName = info.custname;
            this.pwdForm.en_certificateno = info.en_certificateno;
            this.pwdForm.en_custname = info.en_custname;
        } else if (this.isTradeSmsReset) {
            let info = this.$cache.getUser();
            this.pwdForm.certType = info.certificatetype || "00";
            // 无银行卡鉴权时，手机号直接使用登录用户信息，不允许页面修改。
            this.pwdForm.mobileno = this.getLoginMobileno();
        }
        this.biztype =
            this.way === "trade"
                ? this.$const.IMG_BIZTYPE.RESETPWD
                : this.$const.IMG_BIZTYPE.RESETLOGINPWD;
        this.certTypes = this.$cache.getDict("130007");
        if (this.checkBank) {
            this.plaC = "请输入银行预留手机号码";
            this.pwdSet = {
                text: "交易"
            };
            this.filterBanks();
        } else if (this.isTradeSmsReset) {
            this.pwdSet = {
                text: "交易"
            };
        }
    },
    methods: {
        filterBanks() {
            // 获取已开户无线上卡/未绑定银行卡的客户
            this.$util
                .getBusinesBankInfo({
                    businessflag: "9",
                    findtype: this.$const.IMG_BIZTYPE.RESETPWD
                })
                .then((res) => {
                    const bankLists = res.filter((item) => {
                        return (
                            item.authenticateflag === "1" && // 已鉴权才能购买
                            item.ischannelstop === "1" // 屏蔽停用的卡（0-停用，1-正常）
                        );
                    });
                    if (bankLists.length > 0) {
                        this.requiredBankCardList = bankLists;
                        this.chooseBankDisable = false;
                    } else {
                        this.$message.error("您未开户或未绑定支持找回密码的银行卡");
                        this.chooseBankDisable = true;
                    }
                });
        },
        /* 回退到鉴权界面 */
        returnCheck() {
            this.phoneChecked = false;
            this.tradeIdentityChecked = false;
            this.checked = false;
            this.locked = false;
            this.$refs["pwdForm"].resetFields();
            if (this.isTradeSmsReset) {
                this.pwdForm.mobileno = this.getLoginMobileno();
            }
        },
        getLoginMobileno() {
            const info = this.$cache.getUser() || {};
            return info.mobileno || "";
        },
        getLoginEnMobileno() {
            const info = this.$cache.getUser() || {};
            return info.en_mobileno || "";
        },
        isMaskedMobileno(value) {
            return String(value || "").indexOf("*") > -1;
        },
        hasEncryptedLoginMobileno() {
            return !!this.getLoginEnMobileno();
        },
        hasValidLoginMobileno() {
            const mobileno = this.pwdForm.mobileno || this.getLoginMobileno();
            if (this.isMaskedMobileno(mobileno)) {
                return this.hasEncryptedLoginMobileno();
            }
            return /^(1)(\d{10})$/.test(String(mobileno || ""));
        },
        validateLoginMobileno(rule, value, callback) {
            if (
                this.isTradeSmsReset &&
                this.isMaskedMobileno(value) &&
                this.hasEncryptedLoginMobileno()
            ) {
                callback();
                return;
            }
            this.$util.validateMobile(rule, value, callback);
        },
        getTradeSmsMobileParams() {
            if (this.isMaskedMobileno(this.pwdForm.mobileno) && this.hasEncryptedLoginMobileno()) {
                return {
                    params: {
                        en_mobileno: this.getLoginEnMobileno()
                    },
                    isKen: true
                };
            }
            return {
                params: {
                    mobileno: this.pwdForm.mobileno
                },
                isKen: false
            };
        },
        getTradeSmsIdentityParams() {
            // 手机号验证模式以用户本次输入的三要素为准，校验和最终重置都复用同一份参数。
            return {
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                custname: this.pwdForm.userName
            };
        },
        // 再次校验证件号码
        checkCertNoAgain() {
            this.resetTradeSmsVerifyState();
            this.$refs.pwdForm.validateField("certNo");
        },
        resetTradeSmsVerifyState() {
            if (!this.isTradeSmsReset) return;
            this.tradeIdentityChecked = false;
            this.locked = false;
            this.time = 0;
            this.btnMsg = "获取验证码";
            this.$util.btnDisabled(this);
        },
        handleResetNext() {
            return this.mobileCheck();
        },
        validatePwdFields(fields) {
            let mes = "";
            fields.forEach((key) => {
                this.$refs["pwdForm"].validateField(key, function (str) {
                    if (str && !mes) {
                        mes = str;
                    }
                });
            });
            return mes;
        },
        getIdentityVerifyParams() {
            const param = {
                mobileno: this.pwdForm.mobileno || this.mobileno,
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                custname: this.pwdForm.userName
            };
            if (this.tradeIdentityReadonly) {
                param["en_certificateno"] = this.pwdForm.en_certificateno;
                delete param.certificateno;
                param["en_depositname"] = this.pwdForm.en_custname;
                param["custname"] = this.pwdForm.en_custname;
            }
            return param;
        },
        // 新增登录后专用三要素校验接口，避免复用登录前实名校验口导致场景不匹配。
        async verifyIdentityInfo() {
            const res = await userApi.resetTradePwdIdentityVerify(this.getTradeSmsIdentityParams());
            if (res.code == "0") {
                this.tradeIdentityChecked = true;
                return true;
            }
            return false;
        },
        /* 回到找回密码页面 */
        findPwd() {
            this.$router.push({
                name: "resetpwdway",
                query: { tit: "找回密码" }
            });
        },
        /* 显示密码界面 */
        showPwd(flag) {
            this.checked = true;
            this.pwdShow = true;
            this.navs = [
                { val: "验证身份信息", active: true },
                { val: "设置新密码", active: true },
                { val: "完成修改", icon: "fa fa-check" }
            ];
            this.phoneChecked = false;
            if (flag) {
                this.infoChecked = "1";
            }
        },
        /* 提交表单数据,校验手机验证码 */
        // submitForm(formName) {
        //     this.$refs[formName].validate((valid) => {
        //         if (valid) {
        //             if (!this.checkBank || this.bankInfo.bankauthtype == "1") {
        //                 if (!this.locked) {
        //                     this.$message({
        //                         type: "warning",
        //                         message: "请先发送手机短信验证码",
        //                     });
        //                     return false;
        //                 }
        //                 this.locked = true;
        //             } else {
        //                 this.sendBank();
        //             }
        //         } else {
        //             this.$errorScroll();
        //         }
        //     });
        // },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const res = await userApi.resetLoginPwdVerify(
                        this.getIdentityVerifyParams(),
                        this.way === "trade"
                    );
                    if (res.code == "0") {
                        if (this.isTradeSmsReset) {
                            this.tradeIdentityChecked = true;
                            this.$nextTick(() => {
                                if (this.$refs["pwdForm"]) {
                                    this.$refs["pwdForm"].clearValidate();
                                }
                            });
                            return;
                        }
                        this.phoneChecked = false;
                        this.pwdShow = true;
                        this.navs = [
                            { val: "验证身份信息", active: true },
                            { val: "设置新密码", active: true },
                            {
                                val: "完成修改",
                                icon: "fa fa-check"
                            }
                        ];
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        async mobileCode() {
            if (this.isTradeSmsReset) {
                // 点击“获取验证码”后串行完成三要素校验；图形验证码仍按系统参数控制。
                const mes = this.validatePwdFields(["certType", "certNo", "userName", "mobileno"]);
                if (mes !== "") {
                    return false;
                }
                if (!this.tradeIdentityChecked) {
                    const passed = await this.verifyIdentityInfo();
                    if (!passed) {
                        return false;
                    }
                }
                if (this.$cache.getSysParam("10103010") == "2") {
                    await this.getVerifyCode("1");
                } else {
                    this.dialogVisible = true;
                }
                return false;
            }
            const _this = this;
            let mes = "";
            for (const key in _this.pwdForm) {
                if (key !== "verifyCode" && key !== "type") {
                    _this.$refs["pwdForm"].validateField(key, function (str) {
                        if (str) {
                            mes = str;
                            return false;
                        }
                    });
                }
            }
            if (mes !== "") {
                return false;
            }
            // 中台未开启校验图形验证码，或者需要银行卡鉴权时不弹提图形验证码，因为银行卡鉴权接口未实现校验图形验证码功能
            if (this.$cache.getSysParam("10103010") == "2" || this.checkBank) {
                this.getVerifyCode("1");
            } else {
                this.dialogVisible = true;
            }
            return false;
        },
        /* 校验手机验证码 */
        async checkVerifyCode(val) {
            let res = {};
            if (this.checkBank) {
                res = await userApi.restPwdAuthReceive({
                    smscode: val,
                    biztype: this.biztype,
                    mobileno: this.mobileno
                });
            } else {
                res = await userApi.checkSmsCode({
                    smscode: val,
                    biztype: this.biztype
                });
            }
            if (res.code === "0") {
                this.checked = true;
                // 银行卡鉴权通过后，仅多密码模式(10109008=1)直接进入设置新密码，不再展示“验证身份信息”页面
                if (this.checkBank && this.passwordType === "1") {
                    this.phoneChecked = false;
                    this.pwdShow = true;
                    this.navs = [
                        { val: "验证身份信息", active: true },
                        { val: "设置新密码", active: true },
                        { val: "完成修改", icon: "fa fa-check" }
                    ];
                    return;
                }
                if (this.isTradeSmsReset) {
                    this.showPwd();
                    return;
                }
                if (res.data.isbind === "1") {
                    this.phoneChecked = true;
                    this.acctInfo.name = res.data.custname;
                    this.acctInfo.certNo = res.data.certificateno;
                    this.$refs["pwdForm"].resetFields();
                } else {
                    this.pwdShow = true;
                    this.navs = [
                        { val: "验证身份信息", active: true },
                        { val: "设置新密码", active: true },
                        { val: "完成修改", icon: "fa fa-check" }
                    ];
                }
            } else {
                this.checked = false;
                this.$message({
                    type: "warning",
                    message: res.msg || "短信验证码校验失败"
                });
            }
        },
        /* 显示银行卡列表弹框 */
        showBank() {
            if (this.chooseBankDisable) return;
            this.bankVisible = !this.bankVisible;
        },
        /* 回调银行卡信息 */
        getBankMsg(val) {
            this.bankVisible = false;
            if (val && val.bank) {
                this.bankInfo = val.bank;
                this.pwdForm.bankType = this.bankInfo.channelid;
            }
        },
        /* 获取图形验证码值 */
        async getVerifyCode(val) {
            if (this.time > 0) return;
            this.dialogVisible = false;
            if (!val) return;
            if (val || this.$cache.getSysParam("10103010") == "2" || this.checkBank) {
                if (this.checkBank) {
                    this.sendBank(val);
                    return;
                }
                this.mobileno = this.pwdForm.mobileno;
                const mobileParam = this.isTradeSmsReset
                    ? this.getTradeSmsMobileParams()
                    : {
                          params: {
                              mobileno: this.pwdForm.mobileno
                          },
                          isKen: false
                      };
                const res = await userApi.sendSms(
                    {
                        ...mobileParam.params,
                        biztype: this.biztype,
                        verifycode: val
                    },
                    mobileParam.isKen
                );
                if (res.code === "0") {
                    /* 倒计时 */
                    this.time = res.data.sendperiod;
                    this.locked = true;
                    this.$util.btnDisabled(this);
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg
                    });
                }
            }
        },
        /* 回到登录页面 */
        backLogin() {
            this.$router.push("/");
        },
        /* 提交表单数据，重置密码 */
        async pwdOk(action, val) {
            if (action) {
                const encPwd = this.$util.enc(val.pwd);
                let data = {
                    newpwd: encPwd,
                    opertype: "1"
                };
                let res = {};
                if (this.isTradeReset) {
                    const mobileParam = this.isTradeSmsReset
                        ? this.getTradeSmsMobileParams()
                        : {
                              params: {
                                  mobileno: this.mobileno
                              },
                              isKen: false
                          };
                    res = await userApi.resetTradePwd(
                        {
                            ...data,
                            ...mobileParam.params,
                            ...(this.isTradeSmsReset ? this.getTradeSmsIdentityParams() : {})
                        },
                        mobileParam.isKen
                    );
                } else {
                    res = await userApi.resetLoginPwd(data);
                }
                if (res.data) {
                    this.pwdShow = false;
                    if (this.isTradeReset) {
                        this.$cache.refresh("_user").then((res) => {
                            const userOtherInfo = this.$cache.getUserOtherInfo();
                            let returnUrl = "return-back";
                            if (userOtherInfo.specialflag == "3") {
                                returnUrl = "return-home";
                            }
                            userOtherInfo.specialflag = res.specialflag;
                            this.$cache.setUserOtherInfo(userOtherInfo);
                            this.result = {
                                // 结果页面信息
                                cla: "register-success",
                                msg: `您好，${
                                    this.passwordType === "0" ? "交易/登录" : "交易"
                                }密码已重置成功！`,
                                btnMsg: "该密码用于基金的认购/申购、定投等交易行为",
                                btnL: {
                                    //     ctd: "秒后自动跳转登录",
                                    //     time: 10,
                                    //     event: "return-login",
                                },
                                btnR: {
                                    text: "确定",
                                    event: returnUrl
                                }
                            };
                            this.pwdResult = true;
                            this.navs = [
                                { val: "验证身份信息", active: true },
                                { val: "设置新密码", active: true },
                                {
                                    val: "完成修改",
                                    icon: "fa fa-check",
                                    active: true
                                }
                            ];
                        });
                    } else {
                        this.pwdResult = true;
                        this.navs = [
                            { val: "验证身份信息", active: true },
                            { val: "设置新密码", active: true },
                            {
                                val: "完成修改",
                                icon: "fa fa-check",
                                active: true
                            }
                        ];
                    }
                } else {
                    this.result = {
                        // 结果页面信息
                        cla: "register-fail",
                        msg: "很抱歉，密码重置失败！",
                        btnMsg: "你的账户信息已超时，请你重新找回密码",
                        btnL: {
                            text: "返回登录",
                            event: "return-login"
                        },
                        btnR: {
                            text: "找回密码",
                            event: "login-now"
                        }
                    };
                }
            } else {
                this.checked = false;
                this.navs = [
                    { val: "验证身份信息", active: true },
                    { val: "设置新密码" },
                    { val: "完成修改", icon: "fa fa-check" }
                ];
                this.locked = false;
                this.pwdShow = false;
            }
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            if (this.tradeIdentityReadonly) {
                callback();
                return;
            }
            this.$util.validateCertNo(rule, value, callback, this.pwdForm.certType);
        },
        /* 提交表单数据 */
        async mobileCheck() {
            if (this.isTradeSmsReset) {
                // 注册手机号由登录用户信息带入且不可修改；缺失时按需求给固定客服提示。
                if (!this.hasValidLoginMobileno()) {
                    this.$message({
                        type: "warning",
                        message: "未获取到有效注册手机号，请联系客服处理。"
                    });
                    return false;
                }
                const baseMes = this.validatePwdFields([
                    "certType",
                    "certNo",
                    "userName",
                    "mobileno"
                ]);
                if (baseMes !== "") {
                    return false;
                }
                if (!this.tradeIdentityChecked) {
                    const passed = await this.verifyIdentityInfo();
                    if (!passed) {
                        return false;
                    }
                }
                if (!this.locked) {
                    this.$message({
                        type: "warning",
                        message: "请先发送手机验证码！"
                    });
                    return false;
                }
                const mes = this.validatePwdFields(["verifyCode"]);
                if (mes !== "") {
                    return false;
                }
                this.checkVerifyCode(this.pwdForm.verifyCode);
                return false;
            }
            const _this = this;
            let mes = "";
            // 处理银行卡找回密码表单数据校验
            if (_this.checkBank || (!_this.hasTranAcct && _this.hasTranAcct !== undefined)) {
                for (const key in _this.pwdForm) {
                    if (key !== "type") {
                        _this.$refs["pwdForm"].validateField(key, function (str) {
                            if (str) {
                                mes = str;
                                return false;
                            }
                        });
                    }
                }
            } else {
                if (!this.locked) {
                    this.$message({
                        type: "warning",
                        message: "请先发送手机验证码！"
                    });
                    return false;
                }
                for (const key in this.pwdForm) {
                    if (key !== "type") {
                        this.$refs["pwdForm"].validateField(key, function (str) {
                            if (str) {
                                mes = str;
                                return false;
                            }
                        });
                    }
                }
            }
            if (mes !== "") {
                return false;
            }
            if (
                this.checkBank &&
                this.bankInfo.bankauthtype == "0" &&
                this.bankInfo.identifytype == "0"
            ) {
                this.$message({
                    type: "warning",
                    message: "鉴权或签约方式未配置！"
                });
                return;
            }
            if (
                this.checkBank &&
                (this.bankInfo.bankauthtype == "2" ||
                    (this.bankInfo.bankauthtype == "0" && this.bankInfo.identifytype == "2"))
            ) {
                this.sendBank();
            } else {
                if (!this.locked) {
                    this.$message({
                        type: "warning",
                        message: "请先发送手机验证码！"
                    });
                    return false;
                }
                this.checkVerifyCode(this.pwdForm.verifyCode);
            }
            return false;
        },
        /* 银行卡鉴权发送鉴权信息 */
        async sendBank(val) {
            // 检测该网点所在渠道是否支持找回密码
            if (this.bankInfo.businessflag.indexOf("9") < 0) {
                this.$message({
                    type: "warning",
                    message: "该网点所在渠道不支持找回密码！"
                });
                return;
            }
            // let url = "acct/resettradepwd/authsend";
            this.mobileno = this.pwdForm.mobileno;
            let data = {
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                custname: this.pwdForm.userName,
                mobileno: this.pwdForm.mobileno,
                depositcard: this.pwdForm.bankNo,
                channelid: this.bankInfo.channelid,
                channelname: this.bankInfo.name,
                depositname: this.pwdForm.userName,
                biztype: "01",
                bankcode: this.bankInfo.bankcode
            };
            if (this.tradeIdentityReadonly) {
                data["en_certificateno"] = this.pwdForm.en_certificateno;
                delete data.certificateno;
                data["en_depositname"] = this.pwdForm.en_custname;
                delete data.depositname;
                data["custname"] = this.pwdForm.en_custname;
            }
            // 短信鉴权或短信签约
            if (
                this.bankInfo.bankauthtype == "1" ||
                (this.bankInfo.bankauthtype == "0" && this.bankInfo.identifytype == "1")
            ) {
                // 若 paybusinessflag 里有 s（短信鉴权），则 biztype 送 01，调 1013 短信鉴权接口
                // 若 paybusinessflag 里没有 s（短信鉴权），则 biztype 送 02，调 1023 短信签约接口
                if (
                    this.bankInfo.paybusinessflag &&
                    this.bankInfo.paybusinessflag.indexOf("s") > -1
                ) {
                    data.biztype = "01";
                } else {
                    data.biztype = "02";
                }
                this.biztype = data.biztype;
                data = {
                    ...data,
                    verifytype: "1"
                };
                const res = await userApi.restPwdAuthSend(data, this.way === "trade");
                if (res.code == "0") {
                    this.$message({
                        type: "success",
                        message: "发送手机短信验证码成功"
                    });
                    let result = res.data;
                    if (result.comtype && result.comtype === "socket") {
                        // 多密码模式下，银行卡短信鉴权仍需输入并校验短信验证码，不直接进入设密页
                        if (this.passwordType === "1") {
                            this.time = res.data.sendperiod;
                            this.locked = true;
                            this.$util.btnDisabled(this);
                        } else {
                            this.showPwd();
                        }
                    } else {
                        this.time = res.data.sendperiod;
                        this.locked = true;
                        this.$util.btnDisabled(this);
                    }
                }
            } else {
                // 页面鉴权或者页面签约
                data.biztype = this.bankInfo.bankauthtype == "2" ? "01" : "02";
                this.randomToken = this.$util.generateRandomNumber();
                let pagecallbackurl =
                    window.location.origin +
                    "" +
                    "/sale-mid-ump/bank/redirect?token=" +
                    this.randomToken;
                // 建行网联的回调地址配置在银行那边，需要单独处理
                if (this.bankInfo.paycenterid == "0105") {
                    pagecallbackurl = window.location.origin + "" + "/sale-mid-ump/bank/ccb";
                }
                const res = await userApi.restPwdAuthSend(
                    {
                        ...data,
                        paychannel: this.bankInfo.paycenterid,
                        pagecallbackurl: pagecallbackurl,
                        signtype: "0",
                        verifytype: "0"
                    },
                    this.way === "trade"
                );
                if (res.data) {
                    const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                    let pageParam = res.data.bankgateparam ? res.data.bankgateparam : {};
                    if (pageParam) {
                        pageParam = JSON.parse(pageParam);
                    }
                    const bankgateserialno = res.data.bankgateserialno;
                    const reqMethod = res.data.method;
                    this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
                    let params = {
                        token: this.randomToken,
                        certificatetype: this.pwdForm.certType,
                        certificateno: this.pwdForm.certNo,
                        bankcode: this.bankInfo.bankcode,
                        bankcardid: this.acctInfo.bankcardid,
                        depositname: this.pwdForm.userName,
                        mobileno: this.pwdForm.mobileno,
                        paychannel: this.bankInfo.paycenterid,
                        bankgateserialno: bankgateserialno,
                        signtype: "0",
                        isAuthFlag: true,
                        depositcard: this.pwdForm.bankNo
                    };
                    if (this.tradeIdentityReadonly) {
                        params["en_certificateno"] = this.pwdForm.en_certificateno;
                        delete params.certificateno;
                        params["en_depositname"] = this.pwdForm.en_custname;
                        delete params.depositname;
                    }
                    params.isAuthFlag = this.bankInfo.bankauthtype == "2";
                    this.$util.confirmBankAuth(this, params, "BankPageAuthentication", () => {
                        this.showPwd();
                    });
                }
            }
        },
        /* 返回上一页 */
        returnBack() {
            if (this.pwdPattern) {
                this.$router.back();
            } else {
                this.$refs["pwdForm"].resetFields();
                this.checkBank = false;
                this.pwdForm = {
                    // 表单参数配置
                    userName: "",
                    certType: "00",
                    certNo: "",
                    bankType: "",
                    bankNo: "",
                    mobileno: "",
                    verifyCode: "",
                    en_certificateno: "",
                    en_custname: ""
                };
                this.bankInfo = {};
                this.time = 0;
                this.btnMsg = "获取验证码";
                this.$util.btnDisabled(this);
                this.$emit("returnBack");
            }
        },
        // 返回首页
        backHome() {
            this.$router.replace("/home");
        },
        changeCertType() {
            // 改变银行卡
            if (this.pwdForm.certType === "00") {
                this.$refs.bankList.bankLists = this.$refs.bankList.bankListsAll;
            } else if (this.pwdForm.certType === "0B") {
                this.$refs.bankList.bankLists = this.$refs.bankList.bankLists8;
            }
            this.$refs.bankList.initSelBank();
        }
    }
};
</script>
<style lang="scss" scoped>
.comp-reset-num {
    .bizcomp-reset-lpwd-title {
        height: 60px;
        padding: 17px 20px 22px;
        background: #ffffff;
        font-size: 20px;
        font-weight: 500;
        color: var(--color-text-primary);
        box-sizing: border-box;
        .lpwd-title-tip {
            font-size: 16px;
            font-weight: normal;
            color: var(--color-text-accent);
            margin-left: 8px;
        }
    }
    border: 1px solid var(--color-border-base);
    margin-bottom: 20px;
    :deep(.el-form-item__label) {
        font-size: 14px;
        font-weight: normal;
        color: var(--color-text-primary);
    }
    .reset-num-box {
        padding: 38px 0;
    }
    :deep(.step-text) {
        width: 115px !important;
    }
    .send-mobile-text {
        font-size: 24px;
        margin-top: 35px;
        font-weight: normal;
        text-align: center;
        color: var(--color-text-primary);
    }
    .info-box {
        width: 865px;
        height: 40px;
        border-radius: 4px;
        background-color: rgba(224, 234, 255, 0.5);
        box-sizing: border-box;
        border: 1px solid var(--color-border-base);
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: normal;
        color: var(--color-primary);
        .warn-blue {
            margin: 0 8px 0 20px;
        }
    }
    .el-select {
        width: 400px;
    }
    .el-input {
        font-size: $f16;
        width: 400px;
        .get-verify {
            color: $bg18;
            margin-right: 18px;
            cursor: pointer;
        }
        .get-verify-disabled {
            color: $text-color3;
            cursor: not-allowed;
            margin-right: 18px;
        }
        .fa {
            margin-right: 6px;
        }
    }
    :deep(.el-input__inner) {
        font-size: 16px !important;
        font-weight: normal;
        color: var(--color-text-accent) !important;
    }
    .user-info-checked {
        margin-top: 20px;
    }
    .btn-contain {
        text-align: center;
        .cancel-btn {
            width: 180px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            border-radius: 2px;
            background: #e4e4e4;
            cursor: pointer;
            border: none;
            font-size: 16px;
            font-weight: 500;
            color: var(--color-text-regular);
        }
        .next-btn {
            width: 180px;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            background: var(--color-primary);
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
            border: none;
            margin-left: 40px;
        }
    }
    .set-pwd-comp {
        padding-top: 20px;
    }
    .bank-msg {
        position: absolute;
        left: 0;
        top: 0;
        border: 1px solid var(--color-border-base);
        border-radius: 4px;
        text-indent: 15px;
        -ms-border-radius: 4px;
        background-color: #ffffff;
        width: 400px;
        height: 40px;
        z-index: 10;
        .bank-img-sel {
            text-indent: 0;
            display: inline-block;
            width: 340px !important;
            height: 38px;
            margin: 1px 5px;
            padding: 0 10px;
            &.bg-w {
                background: $bg2;
            }
            img {
                margin-top: 3px;
            }
            span {
                color: $text-color2;
                font-size: $f18;
                vertical-align: middle;
                line-height: 30px;
                margin-left: 9px;
                float: left;
                margin-top: 4px;
            }
            img {
                float: left;
            }
            i {
                float: left;
                line-height: 20px;
                margin-left: 10px;
                margin-top: 9px;
            }
        }
    }
}
</style>
